var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyLtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 26.5806C21.1797 26.5806 27 20.7603 27 13.5806C27 6.40086 21.1797 0.580566 14 0.580566C6.8203 0.580566 1 6.40086 1 13.5806C1 20.7603 6.8203 26.5806 14 26.5806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2937 -1C11.4667 -1 8.70314 -0.143725 6.35256 1.46054C4.00197 3.06481 2.16991 5.34502 1.08805 8.01282C0.00619319 10.6806 -0.27687 13.6162 0.274656 16.4483C0.826182 19.2804 2.18753 21.8819 4.18654 23.9238C6.18555 25.9656 8.73244 27.3561 11.5051 27.9195C14.2779 28.4828 17.1518 28.1937 19.7637 27.0886C22.3755 25.9836 24.6079 24.1123 26.1785 21.7113C27.7491 19.3104 28.5874 16.4876 28.5874 13.6C28.5929 11.6883 28.2296 9.79416 27.5184 8.02582C26.8072 6.25747 25.762 4.64953 24.4424 3.29379C23.1229 1.93806 21.5548 0.861078 19.8277 0.124347C18.1006 -0.612384 16.2484 -0.994437 14.3768 -1H14.2937ZM14.536 14.0949L13.0478 19.2208H21.0079C21.0607 19.2189 21.1133 19.2277 21.1627 19.2466C21.2121 19.2654 21.2574 19.2941 21.296 19.3309C21.3345 19.3676 21.3656 19.4118 21.3875 19.4609C21.4093 19.5099 21.4215 19.5629 21.4233 19.6168V19.7511L20.7311 22.1903C20.7006 22.3057 20.6325 22.407 20.5382 22.4777C20.4439 22.5483 20.3288 22.5841 20.2119 22.5792H8.0294L10.0714 15.4736L7.78713 16.1806L8.30628 14.5545L10.5905 13.8475L13.4631 3.87845C13.4947 3.76375 13.563 3.66315 13.6571 3.59268C13.7512 3.52221 13.8656 3.48592 13.9822 3.48959H17.0625C17.1152 3.4877 17.1678 3.49644 17.2172 3.51533C17.2666 3.53421 17.3119 3.56285 17.3505 3.59962C17.389 3.63639 17.4201 3.68057 17.442 3.72963C17.4638 3.77869 17.476 3.83166 17.4778 3.88552V4.01985L15.0551 12.4334L17.3393 11.7264L16.8548 13.4232L14.536 14.0949Z",
    fill: "#345D9D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyLtc);
export default __webpack_public_path__ + "static/media/Currency=LTC.a3514a3f6816c501878e4b4b5082d4c1.svg";
export { ForwardRef as ReactComponent };